/* unplugin-vue-components disabled */import { render } from "./500.vue?vue&type=template&id=5b5fedb6"
const script = {}

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__